import axios from "@/utils/axios";
import { propOr } from "ramda";
import { NUMBER_ELEMENTS_PER_PAGE } from "@/constants/generic";
import {
  RESET_BUILDING_ASSIGNMENTS,
  SET_CREATED_ASSIGNMENTS,
  UPDATE_BUILDING_ASSIGNMENTS,
} from "../constants";
import { format } from "date-fns";

const initialState = () => ({
  buildingAssignments: {
    assignments: [],
    aiTutor: null,
  },
  createdAssignments: [],
  detailScenario: {},
});

const state = initialState();

const getters = {
  getBuildingAssignments: propOr({}, "buildingAssignments"),
  getCreatedAssignments: propOr([], "createdAssignments"),
  buildPagination(state) {
    const pageCounter = getters.studySetsSize(state);
    const numberPages = state.list.count / NUMBER_ELEMENTS_PER_PAGE;
    return {
      pageCounter,
      total: state.list.count || 0,
      next: state.list.next,
      previous: state.list.previous,
      numberPages: Math.floor(numberPages),
    };
  },
  getDetailScenario: propOr({}, "detailScenario"),
};

const mutations = {
  [UPDATE_BUILDING_ASSIGNMENTS](state, updatedBuildingAssignments) {
    state.buildingAssignments = {
      ...state.buildingAssignments,
      ...updatedBuildingAssignments,
    };
  },
  [RESET_BUILDING_ASSIGNMENTS](state) {
    state.buildingAssignments = {
      assignments: [],
      aiTutor: null,
    };
  },
  [SET_CREATED_ASSIGNMENTS](state, createdAssignments) {
    state.createdAssignments = createdAssignments;
  },
};

const actions = {
  updateBuildingAssignments({ commit }, updateAssignments) {
    commit(UPDATE_BUILDING_ASSIGNMENTS, updateAssignments);
  },
  resetBuildingAssignments({ commit }) {
    commit(RESET_BUILDING_ASSIGNMENTS);
  },
  createAssignments({ commit, getters, rootGetters }, assignment_library_id) {
    const buildingAssignments = getters["getBuildingAssignments"];
    const assignedClasses = buildingAssignments.assignments;
    const assignedAITutor = buildingAssignments.aiTutor;
    const aiTutor = assignedAITutor ? [assignedAITutor] : null;
    const organizationId = rootGetters["organization/currentOrganizationId"];
    const payload_assignments = [];
    const now = format(Date.now(), "yyyy-MM-dd HH:mm");
    for (let i = 0; i < assignedClasses.length; i++) {
      const assignment = assignedClasses[i];
      const assignmentWithoutGroup = {
        name: assignment.name,
        study_sets: [],
        ai_tutor: aiTutor,
        due_date: assignment.dueDate + " " + assignment.dueTime,
        start_date: assignment.startTime != "now" ? assignment.startDate + " " + assignment.startTime : now,
        reminder_before_day: assignment.reminderBeforeDay,
        notify_time: assignment.timeNotify,
        assignment_library_id: assignment_library_id,
        assign_now: assignment.assign_now,
      };
      for (let j = 0; j < assignment.groupIds.length; j++) {
        payload_assignments.push({ ...assignmentWithoutGroup, group: assignment.groupIds[j] });
      }
    }
    const requestBody = {
      assignments: payload_assignments,
    };
    return axios.post(`/v1/study-sets/${organizationId}/assignments`, requestBody).then(response => {
      const newAssignments = {
        ...response.data,
      };
      commit(SET_CREATED_ASSIGNMENTS, newAssignments);
      commit(RESET_BUILDING_ASSIGNMENTS);
      return response;
    });
  },
  checkAITutorPermission({ rootGetters }, ids) {
    const requestBody = {
      ids: ids,
    };
    return axios.post("/v1/schools/ai-tutor/access-check/", requestBody).then(response => response.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
